import {Action} from "redux-actions";
import {OnFailure, OnSuccessData} from "../actionHelpers";
import {api} from "../../../api/api";
import {Dispatch} from "react-redux";
import {USER_LOCATIONS_FETCHED} from "./actionType";
import UserLocation from "../../../model/userLocation/UserLocation";

/**
 * User locations fetched successful action.
 * @param {Array<UserLocation>} userLocations all locations for given roles from server.
 * @return {Action<ACQUISITION_CHANNEL_FETCHED>}
 */
function userLocationsFetched(userLocations: Array<UserLocation>): Action<USER_LOCATIONS_FETCHED> {
	return {type: USER_LOCATIONS_FETCHED, payload: {userLocations}};
}

/**
 * Fetch user locations for given roles from server.
 * @param {string[]} roles
 * @param {OnSuccessData} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function fetchUserLocations(roles: string[], onSuccess: OnSuccessData<UserLocation[]>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.userLocationApi.fetchUserLocations(roles).then(userLocations => {
			dispatch(userLocationsFetched(userLocations));
			onSuccess(userLocations);
		}).catch(onFailure);
	};
}
